import { createAsyncThunk } from "@reduxjs/toolkit";
import { ApiError } from "@vana/core";
import { type RecordCustodyParams } from "../../../domain/entities/compliance";
import { type ComplianceDispatch } from "../../config";
import { type ExtraArgument } from "../../extra-argument";
import { type State } from "../../state";
import { thunkTypes } from "../thunk-types";
import { getCase } from "./get-case";

/**
 * Files or relocates the paper portfolio and reloads the case, so the field and
 * the history both show the move the backend just recorded.
 *
 * The rejection carries the backend's error code rather than a thrown error:
 * `unwrap()` hands the caller a serialized error, which keeps the message and
 * drops everything else — and the screen has two refusals to tell apart (the
 * delivery is not delivered yet, the two signed scans are not on file) that it
 * must explain in the operator's terms.
 */
export const recordCustody = createAsyncThunk<
  void,
  RecordCustodyParams,
  { dispatch: ComplianceDispatch; extra: ExtraArgument; state: State; rejectValue: string }
>(thunkTypes.RECORD_CUSTODY, async (params, { dispatch, extra, rejectWithValue }) => {
  try {
    await extra.complianceRepo.recordCustody(params);
  } catch (error) {
    return rejectWithValue(error instanceof ApiError ? (error.apiError?.error_code ?? "") : "");
  }
  await dispatch(getCase({ requestId: params.requestId }));
  return undefined;
});
